__webpack_require__.hmrF = function() { return "umi." + __webpack_require__.h() + ".hot-update.json"; };